(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Sidebar = (function(superClass) {
    extend(Sidebar, superClass);

    function Sidebar() {
      return Sidebar.__super__.constructor.apply(this, arguments);
    }

    Sidebar.prototype.init = function() {
      this.layoutUrl = 'backend/portal/weightings/load-layout';
      this.subHandlers = {
        'WeightSets': {
          'class': 'portal::handlers/weightings/WeightSetsTab'
        },
        'Population': {
          'class': 'portal::handlers/weightings/PopulationTab'
        }
      };
      this.defaultSubHandler = 'WeightSets';
      return this.loadLayout();
    };

    Sidebar.prototype.afterLoadLayout = function(selector, response) {
      var ref, self, sidebar, sub;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      self = this;
      sidebar = $(this.layoutSelector);
      if (response.status == null) {
        sidebar.html(response);
        return;
      }
      sidebar.find('.sel-pp').on('change', function() {
        return sidebar.find('.sel-pp').not(this).val($(this).val());
      });
      sub = this.createSubHandler(this.defaultSubHandler);
      if (sub) {
        return sub.init();
      }
    };

    return Sidebar;

  })(Handler);

}).call(this);
